<template>
  <v-app class="starbridge-app">
    <router-view />
    <unexpected-error />
  </v-app>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import UnexpectedError from "./components/dialog/UnexpectedError.vue";

export default defineComponent({
  name: "App",
  components: { UnexpectedError },
});
</script>

<style lang="scss">
@font-face {
  font-family: "ellipsis-font";
  src: local("Courier");
  unicode-range: U+2026;
}

.v-application {
  .background-layout {
    background-color: #f0f3f5;
  }
  .background-layout-auth {
    background-color: #ffffff;
  }

  font-family: ellipsis-font, "Noto Sans CJK JP", "Noto Sans JP", sans-serif !important;
  h1,
  h2,
  .jp-font,
  .v-card__text,
  .v-card__title {
    font-family: ellipsis-font, "Noto Sans CJK JP", "Noto Sans JP", sans-serif !important;
  }

  /* WIDTH */
  .w-0 {
    width: 0px !important;
  }
  .w-100 {
    width: 100% !important;
  }

  /* HEIGHT */
  .h-auto {
    height: auto !important;
  }
  .h-100 {
    height: 100% !important;
  }

  .transparent {
    background-color: transparent !important;
    border-color: transparent !important;
  }

  .v-breadcrumbs {
    .v-breadcrumbs-item--link {
      color: #2ba4c9;
      font-size: 14px !important;
    }
    .v-breadcrumbs-item--disabled,
    .v-breadcrumbs-divider {
      color: #707f89;
      opacity: 1 !important;
      font-size: 14px !important;
    }
  }

  .v-field__input input {
    color: #3b4043 !important;
    font-size: 14px !important;
  }
  .v-label {
    font-size: 14px !important;
  }

  // btn explanation ?
  .btn-help-custom {
    color: #cdd6dd !important;
  }
  .btn-help-custom:hover {
    color: #2ba4c9 !important;
  }
}

body {
  font-family: "Noto Sans CJK JP", "Noto Sans JP", sans-serif !important;
  /* PADDING */
  .px7 {
    padding-left: 7px !important;
    padding-right: 7px !important;
  }
  .pl10 {
    padding-left: 10px !important;
  }
  .pa14 {
    padding: 14px !important;
  }
  .px14 {
    padding-left: 14px !important;
    padding-right: 14px !important;
  }
  .py14 {
    padding-top: 14px !important;
    padding-bottom: 14px !important;
  }
  .pt14 {
    padding-top: 14px !important;
  }
  .pl14 {
    padding-left: 14px !important;
  }
  .pr14 {
    padding-right: 14px !important;
  }
  .pb14 {
    padding-bottom: 14px !important;
  }
  .pt18 {
    padding-top: 18px !important;
  }
  .pb18 {
    padding-bottom: 18px !important;
  }
  .pr18 {
    padding-right: 18px !important;
  }
  .pt25 {
    padding-top: 25px !important;
  }
  .pt26 {
    padding-top: 26px !important;
  }
  .pl27 {
    padding-left: 27px !important;
  }

  /* MARGIN */
  .mt6 {
    margin-top: 6px !important;
  }
  .ml10 {
    margin-left: 10px !important;
  }
  .ma14 {
    margin: 14px;
  }
  .mt14 {
    margin-top: 14px !important;
  }
  .mb14 {
    margin-bottom: 14px !important;
  }
  .ml14 {
    margin-left: 14px !important;
  }
  .mr14 {
    margin-right: 14px !important;
  }
  .mx14 {
    margin-left: 14px !important;
    margin-right: 14px !important;
  }
  .my14 {
    margin-top: 14px !important;
    margin-bottom: 14px !important;
  }
  .mb18 {
    margin-bottom: 18px !important;
  }
  .mt25 {
    margin-top: 25px !important;
  }

  /* GAP */
  .gc14 {
    column-gap: 14px !important;
  }

  /* LINE HEIGHT */
  .line-height-14 {
    line-height: 14px !important;
  }
  .line-height-24 {
    line-height: 24px !important;
  }
  .line-height-28 {
    line-height: 28px !important;
  }
  .line-height-32 {
    line-height: 32px !important;
  }
  .line-height-48 {
    line-height: 48px !important;
  }

  /* FONT SIZE */
  .font-size-10 {
    font-size: 10px !important;
  }
  .font-size-11 {
    font-size: 11px !important;
  }
  .font-size-12 {
    font-size: 12px !important;
  }
  .font-size-14 {
    font-size: 14px !important;
  }
  .font-size-16 {
    font-size: 16px !important;
  }
  .font-size-18 {
    font-size: 18px !important;
  }
  .font-size-20 {
    font-size: 20px !important;
  }
  .font-size-24 {
    font-size: 24px !important;
  }
  .font-size-28 {
    font-size: 28px !important;
  }
  .font-size-32 {
    font-size: 32px !important;
  }
  .font-size-37 {
    font-size: 37px !important;
  }

  /* FONT COLOR */
  .font-color-1 {
    color: #757575 !important;
  }
  .font-color-2 {
    color: #3b4043 !important;
  }
  .font-color-3 {
    color: #707f89 !important;
  }
  .font-color-4 {
    color: #2ba4c9 !important;
  }
  .font-color-5 {
    color: #db2763 !important;
  }
  .font-color-6 {
    color: #000 !important;
  }
  .font-color-7 {
    color: #ff0000 !important;
  }
  .font-color-8 {
    color: #98a6b5 !important;
  }
  .font-color-9 {
    color: #cdd6dd !important;
  }
  .font-color-10 {
    color: #1c76d2 !important;
  }
  .font-color-11 {
    color: #ffffff !important;
  }
  .font-color-12 {
    color: #f0f3f5 !important;
  }
  .font-color-13 {
    color: #707070 !important;
  }
  .font-color-14 {
    color: #3a99ba !important;
  }
  .font-color-15 {
    color: #1d52a7 !important;
  }
  .font-color-16 {
    color: #666666 !important;
  }
  .font-color-17 {
    color: #3b4043 !important;
  }
  .cyan--text {
    color: #2ba4c9 !important;
  }
  .amber--text {
    color: #ffc009 !important;
  }

  /* BORDER RADIUS */
  .border-radius-0 {
    border-radius: 0px !important;
  }
  .border-radius-2 {
    border-radius: 2px !important;
  }
  .border-radius-3 {
    border-radius: 3px !important;
  }
  .border-radius-4 {
    border-radius: 4px !important;
  }
  .border-radius-6 {
    border-radius: 6px !important;
  }
  .border-radius-8 {
    border-radius: 8px !important;
  }
  .border-radius-10 {
    border-radius: 10px !important;
  }

  /* OTHER */
  .btn-common {
    min-width: 102px !important;
    min-height: 44px !important;
    border-radius: 8px !important;
    font-size: 14px !important;
    box-shadow: 0 0 6px 0px rgba(0, 0, 0, 0.16) !important;

    &.btn-cancel {
      background-color: #f5f5f5 !important;
      color: #3b4043 !important;
    }
  }
  .btn-shadow {
    box-shadow: 0 0 6px 0px rgba(0, 0, 0, 0.16) !important;
  }
  .no_underline {
    text-decoration: none;
  }
  .no-wrap {
    white-space: nowrap !important;
  }
  .word-break-all {
    word-break: break-all !important;
  }
  .title-url-func-table {
    flex-grow: 1 !important;
    flex-basis: 0 !important;
    word-break: break-all !important;
  }
  .ellipsis {
    display: block;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    line-clamp: 1;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
  .ellipsis-2 {
    line-clamp: 2;
    -webkit-line-clamp: 2 !important;
  }
  .ellipsis-3 {
    line-clamp: 3;
    -webkit-line-clamp: 3 !important;
  }
  .info-layout {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    .action-btn {
      position: absolute;
      bottom: 0;
      right: 0;
    }
  }
  .v-btn--variant-text {
    letter-spacing: normal !important;
  }
  .btn-icon-right {
    position: absolute;
    top: 50%;
    right: 8px;
    transform: translateY(-50%);
  }
  .box-shadow {
    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.14), 0px 0px 5px 0px rgba(0, 0, 0, 0.12) !important;
  }
  .custom-disabled.v-btn--disabled {
    color: #ffffff !important;
    background-color: #cdd6dd !important;
    box-shadow: none !important;
    pointer-events: none;
    .v-btn__overlay {
      opacity: 0 !important;
    }
  }
  .v-card-actions {
    gap: 0px !important;
  }
  .select-cursor {
    cursor: pointer !important;
  }
}

.v-label.v-label--clickable {
  opacity: 1 !important;
}

.v-overlay-container {
  .close-icon {
    position: absolute;
    top: 14px;
    right: 14px;
  }
  .close-icon:hover > i {
    color: #000 !important;
  }
  .mdi-checkbox-marked {
    color: #1c76d2 !important;
  }
}
.v-dialog .v-card .v-card-text {
  letter-spacing: normal !important;
}
</style>
